import useAuthStore, { AuthStore } from 'store/auth'

export const useIsloggedIn = () => useAuthStore(({ isLoggedIn }: AuthStore) => isLoggedIn)

export const useUserWeight = () => useAuthStore(({ userWeight }: AuthStore) => userWeight)

export const useAuthActions = () => useAuthStore(({ actions }: AuthStore) => actions)
